// extracted by mini-css-extract-plugin
export default {"container":"style_container__UvMML","icon":"style_icon__SvXmR","title_input_container":"style_title_input_container__Cmq4B","submit_btn":"style_submit_btn__FC-Dl"};